
const state = {
	condition: {},
	auditParams: {
		isBack: false,
		toName:''
	}
}

const mutations = {
	changeCondition (state,payload){
		state.condition = payload;
	},
	changeAuditParams (state,payload){
		state.auditParams = payload;
	},
}

export default {
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/storage/vuex/module/listSearch.js